import { useState } from 'react'

import { ButtonRoot } from '@/components/common/Button'
import { Icon } from '@/components/icons/Icon'
import { COLOR_ID_COLORLESS, COLOR_ID_LABELS, COLOR_LABELS, type ColorIdType, COLORS, type ColorType } from '@/defs/mtg'
import { getColorId, toggleColor } from '@/utils/cardUtil'
import { cn } from '@/utils/commonUtil'

import styles from './InputColorWheel.module.scss'

type Props = {
  colors: ColorType[]
  minColorId?: ColorIdType
  onChange: (colors: ColorType[]) => void
  variant?: 'horizontal'
}

export const InputColorWheel = ({ colors, minColorId, onChange, variant }: Props) => {
  const [isJustEnabled, setIsJustEnabled] = useState(false)
  const minColors = minColorId && minColorId !== COLOR_ID_COLORLESS ? COLOR_ID_LABELS[minColorId].colors : []
  const isColorlessDisabled = minColors.length > 0

  const onClickColor = (color: ColorType) => {
    setIsJustEnabled(colors.length === 0)
    const colorNew = toggleColor({ color, colors, minColorId })
    const isBackToMin = isColorlessDisabled && isJustEnabled && colors.length > 0 && getColorId(colorNew) === minColorId

    onChange(isBackToMin ? [] : toggleColor({ color, colors, minColorId }))
  }

  return (
    <div className={cn(styles.container, { isColorlessDisabled, styles, variant })}>
      {COLORS.filter((c) => !(isColorlessDisabled && c === 'c')).map((color) => (
        <ButtonRoot
          aria-label={`Toggle ${COLOR_LABELS[color].label}`}
          aria-pressed={colors.includes(color)}
          className={cn(styles.button, {
            color,
            isSelected: colors.includes(color),
            styles,
          })}
          key={color}
          onClick={() => onClickColor(color)}
          title={`Toggle ${COLOR_LABELS[color].label}`}
        >
          <span className={styles.icon}>
            <Icon name={`mtg-${color}`} />
          </span>
          {colors.includes(color) && minColors.includes(color) && (
            <span className={styles.lock}>
              <Icon name='lock' />
            </span>
          )}
        </ButtonRoot>
      ))}
    </div>
  )
}
